import ActivityLog from '../components/ActivityLog/ActivitiesLog';

export const DEFAULT_ACTIONS = [
  {
    id: 'activity',
    name: 'Activity',
    icon: 'past-notes-mono',
    color: 'neutral-500',
    component: <ActivityLog />
  }
];
